import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ProductDetail = React.lazy(() => import('.'));

export const productDetailRoutes = [
  new Route({
    path: 'product-detail',
    element: ProductDetail,
    children: [],
  }),
];
